import React from 'react'
import { Link, Logo } from 'components'
import * as Styles from './Description.module.css'

const Description = ({ description }) => {
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.content}>
        <Link to="/">
          <Logo width={8 * 18} color="white" />
        </Link>
        <p>{description}</p>
      </div>
    </div>
  )
}

export default Description
